import { stats } from "@/mocks/homeContent";

export default function CoverStory() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="grid w-full grid-cols-1 items-center gap-10 px-4 py-12 md:px-8 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3">
            <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold tracking-wide text-background-50">
              封面故事
            </span>
            <span className="text-[11px] tracking-widest text-foreground-500">2026.09 / 独家汇总</span>
          </div>

          <h2 className="mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            黑料网站靠谱吗？先把这六个问题看完
          </h2>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            关于黑料网站靠谱吗，网上的说法两极分化得厉害。我们把 128 条读者反馈重新读了一遍，发现真正反复出现的就是六件事：它靠不靠谱、好不好用，以及打不开、审核慢、验证多、广告烦。把它们捋顺，比听任何一句结论都管用。
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            所以这一期不做单选题。左边是问题索引，下面是一条按时间倒序的快讯流，最后是读者原话。你完全可以只挑自己卡住的那一条看。
          </p>

          <div className="mt-8 flex flex-wrap gap-x-10 gap-y-5 border-t border-background-300 pt-8">
            {stats.map((s) => (
              <div key={s.label} className="flex items-baseline gap-2">
                <span className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">{s.value}</span>
                <span className="text-xs text-foreground-600">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#index"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              先看六个高频问题
            </a>
            <a
              href="#timeline"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-center text-sm font-semibold text-foreground-800 transition-colors hover:border-foreground-400"
            >
              查看实时快讯流
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <figure className="relative">
            <div className="h-[320px] w-full overflow-hidden rounded-lg border border-background-300 md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20background%20made%20of%20warm%20ivory%20textured%20paper%20with%20subtle%20fold%20creases%2C%20terracotta%20and%20olive%20ink%20washes%2C%20minimal%20geometric%20shapes%2C%20soft%20diffused%20daylight%2C%20fine%20paper%20grain%2C%20calm%20negative%20space%2C%20no%20text%2C%20high%20detail%2C%20restrained%20warm%20palette&width=900&height=1050&seq=blackliao-cover-01&orientation=portrait"
                alt="黑料网站靠谱吗 封面示意图"
                title="黑料网站靠谱吗 好用吗 真实体验封面图"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <figcaption className="mt-4 flex items-start gap-3 text-xs leading-relaxed text-foreground-600">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
              封面示意图：暖色纸感与克制线条，用来记录这份阅读报告，与站内真实图鉴区分。
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}